export const ADD_LINKS = 'ADD_LINKS';
export const LOAD_LINKS = 'LOAD_LINKS';


// WEBPACK FOOTER //
// ./src/actions/actions.js